<template>
  <div>
    <!-- this is the first div with profile pic and name on it -->
    <div class="d-flex flex-wrap mb-2">
      <div class="mr-2 mb-2" v-for="(user,idx) in parents" :key="idx">
        <avatar v-on:set-active="() => activeUser=user" :user="user" :active="user===activeUser"/>
      </div>
      <div @click="()=> activeUser = {}" class="cursor-pointer">
        <b-avatar variant="info" text="+"
                  style="width: 50px; height: 50px; background:white; color:teal; border:1px solid teal"></b-avatar>
      </div>
    </div>


    <div class="row parent-form-container" v-if="activeUser">
      <div class="col-md-8">
        <profile :key="activeUser.id" :user-data="activeUser" v-on:set-active="(u)=>activeUser=u"/>
      </div>
      <div class="col-md-4" v-if="activeUser && activeUser.id">
        <avatar-profile-with-btns :user="activeUser"></avatar-profile-with-btns>
      </div>
    </div>

  </div>
</template>

<script>
import Avatar from "../components/profileAvatar";
import AvatarProfileWithBtns from "./AvatarProfileWithBtns";
import {mapGetters} from 'vuex'
import Profile from "@/components/Profile";

export default {
  components: {
    Profile,
    Avatar,
    AvatarProfileWithBtns
  },
  data() {
    return {
      activeUser: null
    };
  },

  computed: {
    ...mapGetters(['children', 'parents']),
  },
  methods: {}
};
</script>

<style lang="scss" scoped>

.parent-form-container {

  @media all and (max-width: 768px) {
    flex-direction: column-reverse;
  }

}

.ht-50 {
  height: 50px;
  width: 50px;
}

.bigProfilePic {
  width: 200px;
  height: 200px;
}

.bg-gray-fa {
  background: #fafafa;
}

.containerbigPic {
  min-width: 40%;
}

input, select {
  border: 1px solid;
  padding: 4px;
}

.text-gray-fa {
  color: #ababab;
}

@media (max-width: 768px) {
  .bigProfilePic {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 380px) {
  .smallProfilepic {
    width: 45px;
    height: 45px;
  }

  button {
    padding: 2px;
    line-height: 15px;
  }

  button:last-child {
    padding: 4px;
  }

  .bigProfilePic {
    height: 70px;
    width: 70px;
  }
}
</style>
